module.exports = __webpack_public_path__ + "img/5.6-Pivot-Summary.870680b6.png";